import {
  CREATE_EVENT_SUCCESS,
  FETCH_EVENT_STATUS_END,
  FETCH_EVENT_STATUS_START,
  FETCH_EVENT_STATUS_SUCCESS,
  FETCH_EVENT_SUCCESS,
  FETCH_FILTER_FOR_MODULE_SUCCESS,
  GET_EVENT_SUCCESS,
  SAVE_EVENT_QUERY,
} from "../../constants/ActionTypes";


const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  moduleFilters: {},
  startStatus: false,
  status: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_EVENT_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_EVENT_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_EVENT_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_EVENT_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    case FETCH_FILTER_FOR_MODULE_SUCCESS: {
      return {...state, moduleFilters: action.data};
    }

    case FETCH_EVENT_STATUS_START: {
      return {
        ...state,
        startStatus: true,
      }
    }

    case FETCH_EVENT_STATUS_END: {
      return {
        ...state,
        startStatus: false,
      }
    }

    case FETCH_EVENT_STATUS_SUCCESS: {
      return {
        ...state,
        status: action.data,
      }
    }

    default:
      return state;
  }
}
